export const Location = ({title,address,phone,mobile,link}) => {
    return (
        <div className="section__location">
            <h4>{title}</h4>
            <p>Direcci&oacute;n: <a href={link} target="_blank" rel="noreferrer">{address}</a></p>
            {phone ? <p>Tel: <a href={"tel:" + phone.replace(/\D/g, "")}>{phone}</a></p> : ""}
            {mobile ? <p>Cel: <a href={"tel:" + mobile.replace(/\D/g, "")}>{mobile}</a></p> : ""}
        </div>
    )
}